import { ReactNode } from "react";
import { Box } from "@mui/material";
import { tabHeader } from "../functions/bookingServiceTabHeader.function";

type P = {
  title: string;
  usedItems?: number;
};

export function BookingServiceCustomTapChipLabel({ title, usedItems }: Readonly<P>): ReactNode {
  return <Box sx={{ display: "flex", alignItems: "center" }}>{tabHeader(title, usedItems)}</Box>;
}
